import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { track } from '@xanadu/ui-shared/interfaces/woopra';

import IconAnimatedCheck from '../../../../../images/check-animated.svg';

import Button from '@xanadu/ui-shared/components/widgets/Button';
import Spinner from '@xanadu/ui-shared/components/widgets/Spinner';

import styles from './Feedback.module.scss';

export default class Feedback extends Component {
  static get propTypes() {
    return {
      closeModal: PropTypes.func.isRequired,
      email: PropTypes.string,
      userId: PropTypes.number
    };
  }
  constructor(props) {
    super(props);
    const {
      email
    } = this.props;

    this.state = {
      registrationFeedback: '',
      feedbackEmail: email,
      feedbackPendingRequest: 'default'
    };

    this.handleTextFeedback = this.handleTextFeedback.bind(this);
    this.handleFeedbackRequest = this.handleFeedbackRequest.bind(this);
    this.handleFeedbackEmail = this.handleFeedbackEmail.bind(this);
  }

  handleTextFeedback(e) {
    this.setState({
      registrationFeedback: e.target.value
    });
  }

  handleFeedbackEmail(e) {
    this.setState({
      feedbackEmail: e.target.value
    });
  }

  handleFeedbackRequest() {
    if (this.state.feedbackPendingRequest !== 'in-progress'
      && this.state.feedbackPendingRequest !== 'done') {
      this.setState({
        feedbackPendingRequest: 'in-progress'
      });

      const feedback = this.state.registrationFeedback;
      const feedbackEmail = this.state.feedbackEmail;
      const userAccount = this.props.userId || 'Not Registered';

      track('Registration', 'Registration Feedback', {
        feedback,
        id: userAccount,
        email: feedbackEmail,
      });

      setTimeout(() => {
        this.setState({
          feedbackPendingRequest: 'done'
        });
        setTimeout(() => {
          this.props.closeModal();
        }, 1500);
      }, 1500);
    }
  }

  render() {
    let contentFeedbackButton = 'Send Feedback';
    if (this.state.feedbackPendingRequest === 'in-progress') {
      contentFeedbackButton = (
        <Spinner
          size="small"
          theme="light"
        />
      );
    } else if (this.state.feedbackPendingRequest === 'done') {
      contentFeedbackButton = (
        <IconAnimatedCheck
          className="animated-logo"
        />
      );
    }

    const modalText = 'We noticed that you decided not to complete our sign-up process.';

    return (
      <div className={styles.feedback}>
        <div className={styles.text}>
          <div className={styles.textTop}>
            {modalText}
          </div>
          <div className={styles.textBottom}>
            Would you like to tell us why?
          </div>
        </div>
        <div className={styles.containerInput}>
          <input
            type="text"
            ref={(node) => { this.emailInput = node; }}
            onChange={this.handleFeedbackEmail}
            placeholder="Email address (optional)"
            value={this.state.feedbackEmail}
          />
          <span className={styles.optText}>Optional</span>
          <textarea
            ref={(node) => { this.feedbackInput = node; }}
            onChange={this.handleTextFeedback}
            placeholder="Your feedback..."
            maxLength="280"
          />
          <span className={styles.limitText}>Character Limit 280</span>
        </div>
        <div className={styles.containerActions}>
          <Button
            className="button--topButton"
            disabled={this.state.registrationFeedback === ''}
            sizeType="wider"
            success={this.state.feedbackPendingRequest === 'done'}
            buttonType="primary"
            onClick={this.handleFeedbackRequest}
          >{contentFeedbackButton}</Button>
          <Button
            disabled={false}
            sizeType="wider"
            buttonType="flat"
            onClick={this.props.closeModal}
          >No Thanks</Button>
        </div>
      </div>
    );
  }
}
